import {
  SWITCHGEAR_COUNTER_TABLE_TYPE,
  getSwitchgearCounterSourceOptions,
  getDefaultSwitchgearCounterSourceId,
  getRequiredSwitchgearCounterSourceFields,
} from './sourceUtils';

const getSwitchgearCounterSourceFieldSchema = (sources = [], isOnPremise = false) => {
  const sourceOptions = getSwitchgearCounterSourceOptions(sources);
  const defaultSourceId = getDefaultSwitchgearCounterSourceId(sources, isOnPremise);

  if (isOnPremise || sourceOptions.length === 0) {
    return {};
  }

  return {
    sourceId: {
      type: 'string',
      title: 'Source',
      oneOf: sourceOptions,
      ...(defaultSourceId ? { default: defaultSourceId } : {}),
    },
  };
};

const getAnalyticsTableOptionsSchema = (tableType, sources = [], isOnPremise = false) => {
  const sourceProperties =
    tableType === SWITCHGEAR_COUNTER_TABLE_TYPE
      ? getSwitchgearCounterSourceFieldSchema(sources, isOnPremise)
      : {};
  const sourceRequired =
    tableType === SWITCHGEAR_COUNTER_TABLE_TYPE
      ? getRequiredSwitchgearCounterSourceFields(sources, isOnPremise)
      : [];

  return {
    type: 'object',
    properties: {
      ...sourceProperties,
      defaultSort: {
        type: 'string',
        title: 'Default sort',
        default: 'operation_count:DESC',
        oneOf: [
          { enum: ['operation_count:ASC'], title: 'Operation count (ascending)' },
          { enum: ['operation_count:DESC'], title: 'Operation count (descending)' },
          { enum: ['last_operation_time:ASC'], title: 'Last operation time (ascending)' },
          { enum: ['last_operation_time:DESC'], title: 'Last operation time (descending)' },
          {
            enum: ['days_since_last_operation:ASC'],
            title: 'Days since last operation (ascending)',
          },
          {
            enum: ['days_since_last_operation:DESC'],
            title: 'Days since last operation (descending)',
          },
        ],
      },
    },
    ...(sourceRequired.length > 0 ? { required: sourceRequired } : {}),
  };
};

const getAnalyticsTablePanelSchema = (sources = [], isOnPremise = false) => ({
  title: {
    type: 'string',
    default: 'Analytics Table',
  },
  tableType: {
    type: 'string',
    title: 'Table type',
    default: SWITCHGEAR_COUNTER_TABLE_TYPE,
    oneOf: [
      { enum: [SWITCHGEAR_COUNTER_TABLE_TYPE], title: 'Switchgear Counter' },
      // DISABLED: { enum: ['motor-runtime'], title: 'Motor Runtime' },
    ],
  },
  options: {
    type: 'object',
    properties: {},
  },
  dependencies: {
    tableType: {
      oneOf: [
        {
          properties: {
            tableType: { enum: [SWITCHGEAR_COUNTER_TABLE_TYPE] },
            options: getAnalyticsTableOptionsSchema(
              SWITCHGEAR_COUNTER_TABLE_TYPE,
              sources,
              isOnPremise
            ),
          },
        },
        // DISABLED: motor-runtime table type
        // {
        //   properties: {
        //     tableType: { enum: ['motor-runtime'] },
        //     options: {
        //       type: 'object',
        //       properties: {
        //         defaultSort: {
        //           type: 'string',
        //           title: 'Default sort',
        //           default: 'numberOfStarts:DESC',
        //           oneOf: [
        //             { enum: ['numberOfStarts:ASC'], title: 'Number of starts (ascending)' },
        //             { enum: ['numberOfStarts:DESC'], title: 'Number of starts (descending)' },
        //             { enum: ['startsPerDay:ASC'], title: 'Starts per day (ascending)' },
        //             { enum: ['startsPerDay:DESC'], title: 'Starts per day (descending)' },
        //             { enum: ['runTimeHours:ASC'], title: 'Run time hours (ascending)' },
        //             { enum: ['runTimeHours:DESC'], title: 'Run time hours (descending)' },
        //             { enum: ['runTimePercent:ASC'], title: 'Run time % (ascending)' },
        //             { enum: ['runTimePercent:DESC'], title: 'Run time % (descending)' },
        //           ],
        //         },
        //       },
        //     },
        //   },
        // },
      ],
    },
  },
});

const analyticsTablePanelSchema = getAnalyticsTablePanelSchema();

export { getAnalyticsTablePanelSchema, getAnalyticsTableOptionsSchema };
export default analyticsTablePanelSchema;
